import React from 'react';
import OtpInput from 'react-otp-input';

const PhoneInput = ({ onChange = () => {}, phone = '09'}) => {
	const handleChange = (e) => onChange && onChange(e);
	return (
		<div className="sf-phone-input">
			{/*<div className="country-selector">
				+98
			</div>*/}
			<div className="input-wrap">
				<OtpInput
					value={phone}
					placeholder={'09_________'}
					onChange={handleChange}
					numInputs={11}
					shouldAutoFocus
					isInputNum
					// separator={<span>-</span>}
				/>
				{/*<input onChange={onChange} type="phone" className="sf-phone-input" placeholder='___ ___ ____'/>*/}
			</div>
		</div>
	)
}

export default PhoneInput;